import type { Report } from "@/src/pages/Reports/reports.type";

export type SanctionKind = "account" | "comment" | "event" | "message" | "post";

export type SanctionTarget = {
  kind: SanctionKind;
  /** Identifiant de la **cible**, pas du signalement. */
  id: number;
};

/**
 * Ce qu'un signalement permet de supprimer — et rien de plus.
 *
 * ⚠️ **Clore un signalement ne supprime rien.** `PATCH /moderation/reports/:id`
 * n'écrit que `status`, `reviewed_by_account_id` et `reviewed_at` : c'est une
 * déclaration d'examen, pas une action. La suppression passe par des routes
 * distinctes, que cette fonction désigne.
 *
 * `null` quand la cible n'a pas d'identifiant : le contenu a déjà disparu, il
 * ne reste que la recopie faite au moment du signalement.
 */
export function sanctionTarget(report: Report): SanctionTarget | null {
  switch (report.targetType) {
    case "message":
      return report.targetMessageId === null
        ? null
        : { kind: "message", id: report.targetMessageId };

    case "event":
      return report.targetEventId === null
        ? null
        : { kind: "event", id: report.targetEventId };

    case "account":
      return report.targetAccountId === null
        ? null
        : { kind: "account", id: report.targetAccountId };

    /*
      Publication et commentaire du fil d'actualité.

      ⚠️ La suppression passe ici par `DELETE /moderation/post/…`, qui **efface
      pour de bon** — cascades sur photos, cœurs et commentaires, plus les
      objets S3. C'est autre chose que la suppression d'un auteur, qui est
      douce et laisse la ligne lisible pour la modération.
    */
    case "post":
      return report.targetPostId == null
        ? null
        : { kind: "post", id: report.targetPostId };

    case "comment":
      return report.targetCommentId == null
        ? null
        : { kind: "comment", id: report.targetCommentId };
  }
}
